import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './pages/partial/header/header.component';
import { FooterComponent } from './pages/partial/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { AllGamesComponent } from './pages/all-games/all-games.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { TncComponent } from './pages/tnc/tnc.component';
import { FaqComponent } from './pages/faq/faq.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CategoryComponent } from './pages/category/category.component';
import { GamePlayComponent, SafePipe } from './pages/game-play/game-play.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { LpComponent } from './pages/lp/lp.component';
import { AuthserviceService } from './service/authservice.service';
import { HttpService } from './service/httpService';
import { HttpClientModule } from "@angular/common/http";
import { ContentServiceService } from './service/content-service.service';
import { ViewGamesComponent } from './pages/view-games/view-games.component';
import { TestComponent } from './pages/test/test.component';
import { SplashComponent } from './pages/splash/splash.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import { MsisdnComponent } from './pages/msisdn/msisdn.component';
import { LoadingComponent } from './pages/loading/loading.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AllGamesComponent,
    MyAccountComponent,
    TncComponent,
    FaqComponent,
    CategoryComponent,
    GamePlayComponent,
    SafePipe,
    PrivacyPolicyComponent,
    LpComponent,
    ViewGamesComponent,
    TestComponent,
    SplashComponent,
    MsisdnComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule

  ],
  providers: [AuthserviceService, HttpService, ContentServiceService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
